import React, {useState} from 'react';

const AddUserForm = props => {
    
    const initialFormState = {id: null, name: '', username: ''}
    const [user, setUser] = useState(initialFormState)
    
    const handleInputChange = event => {
        const {name, value} = event.target
        console.log(event.target.name + " : " + event.target.value)
        setUser({ ...user, [name]: value })
    }

    return(
        <form onSubmit={ event => {
            event.preventDefault();
            if (!user.name || !user.username) return
              //console.log(typeof user)
              console.log(user.name + " " + user.username)
              props.addUser(user)
              setUser(initialFormState)
        }}
        >
            <label>Name</label>
            <input type="text" name="name" value={user.name} onChange={handleInputChange} />
            <br/>
            <label>Username</label>
            <input type="text" name="username" value={user.username} onChange={handleInputChange} />
            <br/>
            <button>Add new user</button>
        </form>
    )
}

/*
const arr = ['a', 'b'];
// arr.entries() is [[0, 'a'], [1, 'b']]
for (const [index, element] of arr.entries()) {
    // const [index, element] = [0, 'a'] on 1st iteration, then [1, 'b'], etc. 
    console.log(index, element);
}
*/

export default AddUserForm;